import ChannelsPage from "@/app/channels/pages/ChannelsPage.vue";
import ChannelsSetupTemplate from "@/app/channels/components/templates/ChannelsSetupTemplate.vue";
import SmsChannels from "@/app/channels/components/templates/SocialChannels/SmsChannels.vue";
import EditSmsChannels from "@/app/channels/components/templates/SocialChannels/EditSmsChannels.vue";
import VoiceChannels from "@/app/channels/components/templates/SocialChannels/VoiceChannels.vue";
import ChannelsBoardTemplate from "@/app/channels/components/templates/ChannelsBoardTemplate.vue";
import IntegrationsListTemplate from "@/app/integrations/components/templates/IntegrationsListTemplate.vue";
import WhatsappTemplatesTemplate from "@/app/channels/components/templates/WhatsappTemplatesTemplate.vue";
import SmsTemplatesTemplate from "@/app/channels/components/templates/SmsTemplatesTemplate.vue";
import Template from "@/app/channels/components/templates/Template.vue";

export default [
  {
    path: "/channels",
    name: "channels",
    component: ChannelsPage,
    children: [
      {
        path: "setup",
        component: ChannelsSetupTemplate,
      },
      {
        path: "setup/sms",
        component: SmsChannels,
      },
      {
        path: "editor/sms",
        component: EditSmsChannels,
      },
      {
        path: "setup/voice",
        component: VoiceChannels,
      },
      // {
      //   path: "setup/confirmIntegration",
      //   component: () =>
      //     import(
      //       "@/app/channels/components/templates/SocialChannels/CompleteIntegration.vue"
      //     ),
      // },
      {
        path: "board",
        component: ChannelsBoardTemplate,
      },
      {
        path: "integrations",
        component: IntegrationsListTemplate,
      },
      {
        path: "board/whatsapp-templates/:channel_customer",
        component: WhatsappTemplatesTemplate,
      },
      {
        path: "board/sms-templates/:channel_customer",
        component: SmsTemplatesTemplate,
      },
      {
        path: "template",
        component: Template,
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
];
